// import service from '../allservices.jsx'

// let baseUrl= localStorage.getItem('serviceUrl')

// let applicationid= localStorage.getItem('applicationId')
// 
export function publicKey(actionCallback) {
    fetch(localStorage.getItem('serviceUrl') + "/public/card/getkey/"+ `${localStorage.getItem('applicationId')}`, {
        headers: new Headers({
            'Content-Type': 'application/json'
        })
    })
        .then(response => {
            if (response.status === 200 || response.status === 201) {
                response.json().then(json => actionCallback(json, "success"))
            } else {
                response.json().then(json => actionCallback(json, "Error"))

            }
        })
}


// WEBPACK FOOTER //
// ./src/services/components/public_key.jsx